/*
 * Marketplace specific configuration.
 *
 * Every filter needs to have following keys:
 * - id:     Unique id of the filter.
 * - label:  The default label of the filter.
 * - type:   String that represents one of the existing filter components:
 *           BookingDateRangeFilter, KeywordFilter, PriceFilter,
 *           SelectSingleFilter, SelectMultipleFilter.
 * - group:  Is this 'primary' or 'secondary' filter?
 *           Primary filters are visible on desktop layout by default.
 *           Secondary filters are behind "More filters" button.
 *           Read more from src/containers/SearchPage/README.md
 * - queryParamNames: Describes parameters to be used with queries
 *                    (e.g. 'price' or 'pub_amenities'). Most of these are
 *                    the same between webapp URLs and API query params.
 *                    You can't change 'dates', 'price', or 'keywords'
 *                    since those filters are fixed to a specific attribute.
 * - config: Extra configuration that the filter component needs.
 *
 * Note 1: Labels could be tied to translation file
 *         by importing FormattedMessage:
 *         <FormattedMessage id="some.translation.key.here" />
 *
 * Note 2: If you need to add new custom filter components,
 *         you need to take those into use in:
 *         src/containers/SearchPage/FilterComponent.js
 *
 * Note 3: If you just want to create more enum filters
 *         (i.e. SelectSingleFilter, SelectMultipleFilter),
 *         you can just add more configurations with those filter types
 *         and tie them with correct extended data key
 *         (i.e. pub_<key> or meta_<key>).
 */

// import Cookies from 'universal-cookie';
import React from 'react';

import { FormattedMessage } from './util/reactIntl';

// const cookies = new Cookies();

export const filters = [
  {
    id: 'category',
    label: (
      <>
        <FormattedMessage id="filter.topic" />
      </>
    ),
    type: 'SelectSingleFilter',
    group: 'primary',
    queryParamNames: ['pub_category'],
    config: {
      // "key" is the option you see in Flex Console.
      // "label" is set here for the UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      // img are the icons/images which belong to the project backround (for example key:Bildung)
      searchMode: 'has_any',
      options: [
        {
          key: 'Bildung',
          label: (
            <>
              <img src={require('./assets/categories/education.png')} width="40px" alt=""></img> {' '} 

              <FormattedMessage id="filter.category.education" />
             </>
          ),
        },
        {
          key: 'Naturschutz',
          label: (
            <>
              <img src={require('./assets/categories/environment.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.category.environment" />
            </>
          ),
        },
        {
          key: 'Tierschutz',
          label: (
            <>
              <img src={require('./assets/categories/animal.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.category.animalCare" />
            </>
          ),
        },
        {
          key: 'Equality',
          label: (
            <>
              <img src={require('./assets/categories/equality.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.category.equality" />
            </>
          ),
        },
        {
          key: 'Health',
          label: (
            <>
              <img src={require('./assets/categories/health.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.category.health" />
            </>
          ),
        },
        {
          key: 'Sports',
          label: (
            <>
              <img src={require('./assets/categories/sports.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.category.sports" />
            </>
          ),
        },

        // { key: 'Bildung', label: <FormattedMessage id="filter.category.Bildung" /> },
        // { key: 'Naturschutz', label:  },
        // { key: 'Tierschutz', label: <FormattedMessage id="filter.category.Tierschutz" /> },
        // { key: 'Community', label: <FormattedMessage id="filter.category.Community" /> },
      ],
    },
  },

  {
    id: 'languages',
    label: (
      <>
        <FormattedMessage id="filter.languages" />
      </>
    ),
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_languages'],
    config: {
      // "key" is the option you see in Flex Console.
      // "label" is set here for the UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      searchMode: 'has_any',
      options: [
        {
          key: 'english',
          label: (
            <>
              <FormattedMessage id="filter.language.english" />{' '}
            </>
          ),
        },
        {
          key: 'spanish',
          label: (
            <>
              <FormattedMessage id="filter.language.spanish" />{' '}
            </>
          ),
        },
        {
          key: 'french',
          label: (
            <>
              {' '}
              <FormattedMessage id="filter.language.french" />
            </>
          ),
        },
        {
          key: 'german',
          label: (
            <>
              <FormattedMessage id="filter.language.german" />
            </>
          ),
        },
        {
          key: 'portuguese',
          label: (
            <>
              {' '}
              <FormattedMessage id="filter.language.portuguese" />
            </>
          ),
        },
        {
          key: 'chinese',
          label: (
            <>
              {' '}
              <FormattedMessage id="filter.language.chinese" />
            </>
          ),
        },

        // { key: 'Bildung', label: <FormattedMessage id="filter.category.Bildung" /> },
        // { key: 'Naturschutz', label: <FormattedMessage id="filter.category.Naturschutz" /> },
        // { key: 'Tierschutz', label: <FormattedMessage id="filter.category.Tierschutz" /> },
        // { key: 'Community', label: <FormattedMessage id="filter.category.Community" /> },
      ],
    },
  },

  {
    id: 'roomtype',
    label: (
      <>
        <FormattedMessage id="filter.roomtype" />
      </>
    ),
    type: 'SelectSingleFilter',
    group: 'primary',
    queryParamNames: ['pub_roomtype'],
    config: {
      searchMode: 'has_any',

      // "key" is the option you see in Flex Console.
      // "label" is set here for the UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      options: [
        {
          key: 'singlebedroom',
          label: (
            <>
              <img src={require('./assets/icons/roomtypes/onebedroom.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="roomtypes.singlebedroom" />
            </>
          ),
          labelMsgId: 'roomtypes.singlebedroom',
        },
        {
          key: 'doublebedroom',
          label: (
            <>
              <img src={require('./assets/icons/roomtypes/doublebedroom.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="roomtypes.doublebedroom" />
              {/* <img className="info1" src={require('./assets/icons/info-icon-thick.png')} width="25px" alt=""></img>{' '} */}
            </>
          ),
          labelMsgId: 'roomtypes.doublebedroom',
        },
        {
          key: 'twobedroom',
          label: (
            <>
              <img src={require('./assets/icons/roomtypes/twobedroom.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="roomtypes.twobedroom" />
              {/* <img className="info2" src={require('./assets/icons/info-icon-thick.png')} width="25px" alt=""></img>{' '} */}
            </>
          ),
          labelMsgId: 'roomtypes.twobedroom',
        },
        {
          key: 'shared_bedroom',
          label: (
            <>
              <img src={require('./assets/icons/roomtypes/shared_bedroom.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="roomtypes.shared_bedroom" />
              {/* <img className="info3" src={require('./assets/icons/info-icon-thick.png')} width="25px" alt=""></img>{' '} */}
            </>
          ),
          labelMsgId: 'roomtypes.shared_bedroom',
        },
        {
          key: 'entire_accomodation',
          label: (
            <>
              <img
                src={require('./assets/icons/roomtypes/entire_accomodation.png')}
                width="40px"
                alt=""
              ></img>{' '}
              <FormattedMessage id="roomtypes.entire_accomodation" />
              {/* <img className="info4" src={require('./assets/icons/info-icon-thick.png')} width="25px" alt=""></img>{' '} */}
            </>
          ),
          labelMsgId: 'roomtypes.entire_accomodation',
        },
        {
          key: 'camping',
          label: (
            <>
              <img src={require('./assets/icons/roomtypes/camping.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="roomtypes.camping" />
              {/* <img className="info5" src={require('./assets/icons/info-icon-thick.png')} width="25px" alt=""></img>{' '} */}
            </>
          ),
          labelMsgId: 'roomtypes.camping',
        },
      ],
    },
  },
  {
    id: 'price',
    label: (
      <>
        <FormattedMessage id="filter.price" />
      </>
    ),
    type: 'PriceFilter',
    group: 'primary',
    // Note: PriceFilter is fixed filter,
    // you can't change "queryParamNames: ['price'],"
    queryParamNames: ['price'],
    // Price filter configuration
    // Note: unlike most prices this is not handled in subunits
    config: {
      min: 0,
      max: 950,
      step: 5,
    },
  },
  {
    id: 'customCurrency',
    label: 'Currency',
    type: 'SelectSingleFilter',
    group: 'secondary',
    queryParamNames: ['custom_Currency'],
    config: {
      // Schema type is enum for SelectSingleFilter
      schemaType: 'enum',
      options: [
        { key: 'Dollar', label: '$ Dollar ' },
        { key: 'Euro', label: '€ Euro' }
      ],
    },
  }, 
  
  {
    id: 'characteristics',
    label: 'Highlights',
    type: 'SelectMultipleFilter',
    group: 'primary',
    queryParamNames: ['pub_characteristics'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_any',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      options: [
        {
          key: 'comfort',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Komfort.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.comfort" />
            </>
          ),
        },
        {
          key: 'adventure',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/adventure.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.adventure" />
            </>
          ),
        },
        {
          key: 'nature',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Nature.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.nature" />
            </>
          ),
        },
        {
          key: 'near_beach',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Beach.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.near_beach" />
            </>
          ),
        },
        {
          key: 'animallovers',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Animals.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.animallovers" />
            </>
          ),
        },
        {
          key: 'sportlovers',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Sport.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.sportlovers" />
            </>
          ),
        },

        {
          key: 'familyfriendly',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Family.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.familyfriendly" />
            </>
          ),
        },

        {
          key: 'trekking',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Trekking.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.trekking" />
            </>
          ),
        },
        {
          key: 'culture',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Theatre.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.culture" />
            </>
          ),
        },
        {
          key: 'barrier_free',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/barrierefreiheit.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.barrier_free" />
            </>
          ),
        },
        {
          key: 'accessibility',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Bus.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.accessibility" />
            </>
          ),
        },
        {
          key: 'projecttours_possible',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Projektbesuch_.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.projecttours_possible" />
            </>
          ),
        },
        {
          key: 'projecttours_impossible',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Projektbesuch_Cancel.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.characteristics.projecttours_impossible" />
            </>
          ),
        },
      ],
    },
  },

  // {
  //   id: 'keyword',
  //   label: 'Keyword',
  //   type: 'KeywordFilter',
  //   group: 'primary',
  //   // Note: KeywordFilter is fixed filter,
  //   // you can't change "queryParamNames: ['keywords'],"
  //   queryParamNames: ['keywords'],
  //   // NOTE: If you are ordering search results by distance
  //   // the keyword search can't be used at the same time.
  //   // You can turn on/off ordering by distance from config.js file.
  //   config: {},
  // },

  {
    id: 'food',
    label: (
      <>
        <FormattedMessage id="EditListingOffersForm.foodTitle" />
      </>
    ),
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_food'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_all',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.

      options: [
        {
          key: 'breakfast_inclusive',
          label: (
            <>
              <img src={require('./assets/icons/meals/Breakfast.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.breakfast_inclusive" />
            </>
          ),
        },
        {
          key: 'breakfast_for_sale',
          label: (
            <>
              <img src={require('./assets/icons/meals/Breakfast-paid.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.breakfast_for_sale" />
            </>
          ),
        },
        {
          key: 'lunch_inclusive',
          label: (
            <>
              <img src={require('./assets/icons/meals/Lunch.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.lunch_inclusive" />
            </>
          ),
        },
        {
          key: 'lunch_for_sale',
          label: (
            <>
              <img src={require('./assets/icons/meals/Lunch-paid.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.lunch_for_sale" />
            </>
          ),
        },

        {
          key: 'dinner_inclusive',
          label: (
            <>
              <img src={require('./assets/icons/meals/Abendessen.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.dinner_inclusive" />
            </>
          ),
        },
        {
          key: 'dinner_for_sale',
          label: (
            <>
              <img src={require('./assets/icons/meals/Abendessen-paid.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.dinner_for_sale" />
            </>
          ),
        },
        {
          key: 'vegetarian_options',
          label: (
            <>
              <img src={require('./assets/icons/meals/Vegetarian_.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.vegetarian_options" />
            </>
          ),
        },
        {
          key: 'vegan_options',
          label: (
            <>
              <img src={require('./assets/icons/meals/Vegan.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.vegan_options" />
            </>
          ),
        },

        {
          key: 'coffee_tee',
          label: (
            <>
              <img src={require('./assets/icons/meals/Coffee_.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.food.coffee_tee" />
            </>
          ),
        },
      ],
    },
  },

  {
    id: 'amenities',
    label: (
      <>
        <FormattedMessage id="EditListingWizard.tabLabelFeatures" />
      </>
    ),
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_amenities'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_all',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.

      options: [
        {
          key: 'light',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Lampe.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.light" />
            </>
          ),
        },
        {
          key: 'electricity',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Electricity.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.electricity" />
            </>
          ),
        },

        {
          key: 'bedsheets',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Bettwäsche_.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.bedsheets" />
            </>
          ),
        },
        {
          key: 'sink',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Sink.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.sink" />
            </>
          ),
        },
        {
          key: 'shower',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Shower.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.shower" />
            </>
          ),
        },
        {
          key: 'toilet',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Toilet.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.toilet" />
            </>
          ),
        },

        {
          key: 'privat_bathroom',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Bathroom.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.privat_bathroom" />
            </>
          ),
        },
        {
          key: 'shared_bathroom',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Bathroom-Shared.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.shared_bathroom" />
            </>
          ),
        },
        {
          key: 'private_kitchen',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Kitchen.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.private_kitchen" />
            </>
          ),
        },
        {
          key: 'shared_kitchen',
          label: (
            <>
              <img src={require('./assets/icons/equipment/SharedKitchen.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.shared_kitchen" />
            </>
          ),
        },
        {
          key: 'internet',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Wifi.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.internet" />
            </>
          ),
        },
        {
          key: 'computer',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Computer.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.computer" />
            </>
          ),
        },
        {
          key: 'tv',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Tv.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.tv" />
            </>
          ),
        },
        {
          key: 'mosquito_net',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Moskito.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.mosquito_net" />
            </>
          ),
        },
        {
          key: 'towels',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Handtücher_.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.towels" />
            </>
          ),
        },
        {
          key: 'fan',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Ventilator_.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.fan" />
            </>
          ),
        },
        {
          key: 'air_conditioning',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Klimaanlage.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.air_conditioning" />
            </>
          ),
        },

        {
          key: 'heating',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Heater.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.heating" />
            </>
          ),
        },
        {
          key: 'safe',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Security_Locker.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.safe" />
            </>
          ),
        },

        {
          key: 'wardrobe',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Dresser.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.wardrobe" />
            </>
          ),
        },

        {
          key: 'parking',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Parking.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.parking" />
            </>
          ),
        },

        {
          key: 'luggage_storage',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Luggage.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.luggage_storage" />
            </>
          ),
        },

        {
          key: 'laundry_facilities',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Waschküche_.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.amenities.laundry_facilities" />
            </>
          ),
        },
      ],
    },
  },

  // {
  //   id: 'accomodationtype',
  //   label: 'Unterkunftstyp',
  //   type: 'SelectSingleFilter',
  //   group: 'secondary',
  //   queryParamNames: ['pub_accomodationtype'],
  //   config: {
  //     searchMode: 'has_all',

  //     options: [
  //       { key: 'Lodge', label: 'Lodge' },
  //       { key: 'Hostel', label: 'Hostel' },
  //       { key: 'Homestay', label: 'Homestay' },
  //     ],
  //   },
  // },

  {
    id: 'surroundings',
    label: (
      <>
        <FormattedMessage id="filter.surroundings" />
      </>
    ),
    type: 'SelectMultipleFilter',
    group: 'secondary',
    queryParamNames: ['pub_surroundings'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_any',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.

      options: [
        {
          key: 'supermarket',
          label: (
            <>
              <img src={require('./assets/icons/surroundings/Supermarket.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.surroundings.supermarket" />
            </>
          ),
        },
        {
          key: 'restaurant',
          label: (
            <>
              <img src={require('./assets/icons/surroundings/Restaurant.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.surroundings.restaurant" />
            </>
          ),
        },
        {
          key: 'facility',
          label: (
            <>
              <img src={require('./assets/icons/surroundings/Doctor.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.surroundings.facility" />
            </>
          ),
        },
        {
          key: 'washing',
          label: (
            <>
              <img src={require('./assets/icons/equipment/Waschküche_.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.surroundings.washing" />
            </>
          ),
        },

        {
          key: 'bank',
          label: (
            <>
              <img src={require('./assets/icons/surroundings/Bank.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.surroundings.bank" />
            </>
          ),
        },
        {
          key: 'public_transport',
          label: (
            <>
              <img src={require('./assets/icons/characteristics/Bus.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.surroundings.public_transport" />
            </>
          ),
        },
        {
          key: 'tour',
          label: (
            <>
              <img src={require('./assets/icons/surroundings/Touranbieter.png')} width="40px" alt=""></img>{' '}
              <FormattedMessage id="filter.surroundings.tour" />
            </>
          ),
        },
      ],
    },
  },
  
  // {
  //   id: 'dates',
  //   label: 'Dates',
  //   type: 'BookingDateRangeFilter',
  //   group: 'secondary',

  //   queryParamNames: ['dates'],
  //   config: {},
  // },
];

export const sortConfig = {
  // Enable/disable the sorting control in the SearchPage
  active: true,

  // Note: queryParamName 'sort' is fixed,
  // you can't change it since Flex API expects it to be named as 'sort'
  queryParamName: 'sort',

  // Internal key for the relevance option, see notes below.
  relevanceKey: 'relevance',

  // Keyword filter is sorting the results already by relevance.
  // If keyword filter is active, we need to disable sorting.
  conflictingFilters: ['keyword'],

  options: [

    /*{
      These are not needed right now ->

      
      key: '-createdAt',
      label: (
        <>
          <FormattedMessage id="filter.sort.newest" />
        </>
      ),
    },
    {
      key: 'createdAt',
      label: (
        <>
          <FormattedMessage id="filter.sort.oldest" />
        </>
      ),
    },*/

    {
      key: '-price',
      label: (
        <>
          <FormattedMessage id="filter.sort.lowest_price" />
        </>
      ),
    },
    {
      key: 'price',
      label: (
        <>
          <FormattedMessage id="filter.sort.highest_price" />
        </>
      ),
    },

    // The relevance is only used for keyword search, but the
    // parameter isn't sent to the Marketplace API. The key is purely
    // for handling the internal state of the sorting dropdown.
    /*
    { key: 'relevance', label: 'Relevance', longLabel: 'Relevance (Keyword search)' },
    */
  ],
};

